var _path, _path2, _path3, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_06-plan",
    "data-name": "06-plan"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,1V7a2.006,2.006,0,0,1-2,2H9Z",
    style: {
      fill: "#4a98f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,5V59a4,4,0,0,1-4,4H13a4,4,0,0,1-4-4V9h6a2.006,2.006,0,0,0,2-2V1H51A4,4,0,0,1,55,5Z",
    style: {
      fill: "#65b1fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,17H32a0,0,0,0,1,0,0V32a0,0,0,0,1,0,0H17a0,0,0,0,1,0,0V19A2,2,0,0,1,19,17Z",
    style: {
      fill: "#a3d4ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,17H47a0,0,0,0,1,0,0V32a0,0,0,0,1,0,0H34a2,2,0,0,1-2-2V17a0,0,0,0,1,0,0Z",
    transform: "translate(79 49) rotate(-180)",
    style: {
      fill: "#bfe1ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,32H47a0,0,0,0,1,0,0V47a0,0,0,0,1,0,0H32a0,0,0,0,1,0,0V34A2,2,0,0,1,34,32Z",
    transform: "translate(79 79) rotate(180)",
    style: {
      fill: "#a3d4ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,32H32a0,0,0,0,1,0,0V47a0,0,0,0,1,0,0H19a2,2,0,0,1-2-2V32a0,0,0,0,1,0,0Z",
    style: {
      fill: "#bfe1ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,16H28v2h3V31H28v2h3v3h2V33h8V31H33V18H45a1,1,0,0,1,1,1v5h2V19A3,3,0,0,0,45,16Z",
    style: {
      fill: "#dbeeff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,45a1,1,0,0,1-1,1H33V43.414l4.707-4.707-1.414-1.414-5,5A1,1,0,0,0,31,43v3H19a1,1,0,0,1-1-1V33h3a1,1,0,0,0,.707-.293l5-5-1.414-1.414L20.586,31H18V19a1,1,0,0,1,1-1h2a1,1,0,0,0,.707-.293l5-5-1.414-1.414L20.586,16H19a3,3,0,0,0-3,3V45a3,3,0,0,0,3,3H45a3,3,0,0,0,3-3V36H46Z",
    style: {
      fill: "#dbeeff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 50,
    width: 2,
    height: 2,
    style: {
      fill: "#dbeeff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 50,
    width: 28,
    height: 2,
    style: {
      fill: "#dbeeff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 54,
    width: 28,
    height: 2,
    style: {
      fill: "#dbeeff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63 52 63 59 61 59 55 59 55 52 61 52 63 52",
    style: {
      fill: "#d2eb5a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63 55 63 59 61 59 55 59 55 55 61 55 63 55",
    style: {
      fill: "#b4d241"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,59v4H51a4,4,0,0,0,4-4Z",
    style: {
      fill: "#d2eb5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.83,32.33c-1.3-2.1-3.22-4.28-5.83-5.04V19l3,2Z",
    style: {
      fill: "#faa68e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,49v3H55V41.48C50,39.58,50,33,50,33H46a3,3,0,0,1,0-6h7a6.858,6.858,0,0,1,2,.29c2.61.76,4.53,2.94,5.83,5.04A21.866,21.866,0,0,1,63,37V47A1.959,1.959,0,0,1,61,49Z",
    style: {
      fill: "#ffdecf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,30a3,3,0,0,1,3-3H46a3,3,0,0,0,0,6h3a3,3,0,0,1-3-3Z",
    style: {
      fill: "#ffcdbe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,33H50s0,6.58,5,8.48V52h3V41.48C53,39.58,53,33,53,33Z",
    style: {
      fill: "#ffcdbe"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64,47V37a1.033,1.033,0,0,0-.042-.287,22.619,22.619,0,0,0-2.2-4.811L58.97,20.758a1,1,0,0,0-.415-.59L56,18.465V5a5.006,5.006,0,0,0-5-5H17a1,1,0,0,0-.707.293l-8,8A1,1,0,0,0,8,9V59a5.006,5.006,0,0,0,5,5H51a5.009,5.009,0,0,0,4.9-4H60v3h2V60h1a1,1,0,0,0,1-1V52a1,1,0,0,0-1-1H62V49.833A2.818,2.818,0,0,0,64,47Zm-2,0a.915.915,0,0,1-1,1,1,1,0,0,0-1,1v2H56V42.8a10.081,10.081,0,0,0,2,.2V41c-6.891,0-7-7.675-7-8a1,1,0,0,0-1-1H46a2,2,0,0,1,0-4h7c5.761,0,8.625,8.023,9,9.156ZM57.123,21.618l1.67,6.681A9.649,9.649,0,0,0,56,26.573v-5.7ZM16,3.414V7a1,1,0,0,1-1,1H11.414ZM51,62H13a3,3,0,0,1-3-3V10h5a3,3,0,0,0,3-3V2H51a3,3,0,0,1,3,3V26.067A8.151,8.151,0,0,0,53,26H46a4,4,0,0,0,0,8h3.048c.251,2.708,1.54,6.462,4.952,8.134V59A3,3,0,0,1,51,62Zm11-4H56V53h6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31,36h2V33h8V31H33V18H45a1,1,0,0,1,1,1v5h2V19a3,3,0,0,0-3-3H28v2h3V31H28v2h3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46,45a1,1,0,0,1-1,1H33V43.414l4.707-4.707-1.414-1.414-5,5A1,1,0,0,0,31,43v3H19a1,1,0,0,1-1-1V33h3a1,1,0,0,0,.707-.293l5-5-1.414-1.414L20.586,31H18V19a1,1,0,0,1,1-1h2a1,1,0,0,0,.707-.293l5-5-1.414-1.414L20.586,16H19a3,3,0,0,0-3,3V45a3,3,0,0,0,3,3H45a3,3,0,0,0,3-3V36H46Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 50,
    width: 2,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 50,
    width: 28,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 54,
    width: 28,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG4);
export default __webpack_public_path__ + "static/media/G4.85506cfa8580de4f95cf6ad405c8b251.svg";
export { ForwardRef as ReactComponent };